import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { ViewApplicationSearchModel } from "src/app/model/ViewApplicationSearchModel";
import { ViewApplicationService } from "src/app/services/view-application.service";

@Component({
  selector: "app-secure-view-application-documents",
  templateUrl: "./view-application-documents.component.html",
  styleUrls: ["./view-application-documents.component.scss"],
})
export class ViewApplicationDocumentsComponent implements OnInit {
  page: Page<ViewApplicationSearchModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  isLoading: boolean = false;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<ViewApplicationSearchModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicantName",
    "schemeCategory",
    "panNumber",
    "preLotteryStatus",
    "postLotteryStatus",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private viewApplicationService: ViewApplicationService,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem("app-secure-view-application-filterText")
        , [Validators.required, Validators.minLength(3)])
    });  
       this.filterForm.controls['filterText'].setValue(null);
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.page = null;
    this.dataSource = new MatTableDataSource();
    this.currentPage = 0;
    this.paginator.pageIndex = this.currentPage;
    this.paginator.length = 0;
  }

  onLoad() {
    this.isLoading = true;
    this.viewApplicationService.fetchFilterList(this.currentPage, this.pageSize, 
      this.filterForm.value.filterText).subscribe((page) => {
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
      this.isSearchDisabled = false;
      this.isLoading = false;
    },
    (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.page = null;
      this.dataSource = null;
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;

      localStorage.setItem("app-secure-view-application-filterText", this.filterForm.value.filterText);
      this.onLoad();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Search", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  showStatusClass(status: string) {
    let statusClass = 'text-white p-1 pl-2 pr-2 text-sm border-round';
    if(status === 'Verified' || status === 'Answered') {
      return statusClass + ' bg-green-400';
    }
    else if(status === 'Not Applicable') {
      return statusClass + ' surface-700';
    }
    else if(status?.indexOf('Pending') >= 0) {
      return statusClass + ' bg-orange-400';
    }
    else {
      return statusClass + ' bg-orange-400';
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    if(this.filterForm.value.filterText) {
      this.onSearch();
    }
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

}